import React from "react";
import BlogCard from "components/blog-card";
import { formatDate } from "helpers/formatDate";

const Headlines = ({ data, title }) => {
  return (
    <div className="py-9">
      <div className="container">
        <div className="mb-16">
          <h2 className="header text-center">{title}</h2>
          <p className="paragraph text-gray-600 mt-2.5 text-center">
            {`Last updated on ${formatDate(data?.[0]?.date || "2024-07-04")}`}
          </p>
        </div>
        {data?.[0] && (
          <BlogCard
            bigHeading={true}
            blog={data[0]}
            fullWidth={true}
            showParagraph={true}
          />
        )}
        <div className="grid grid-cols-3 gap-7 mt-36 sm:grid-cols-1 sm:mt-6">
          {data &&
            data
              .filter((_, i) => i > 0)
              .map((blog, index) => (
                <BlogCard
                  bigHeading={false}
                  blog={blog}
                  fullWidth={false}
                  showParagraph={false}
                  key={index}
                />
              ))}
        </div>
      </div>
    </div>
  );
};

export default Headlines;
